import { Grid, IconButton, Paper, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { WSIcons } from "../../commonFunctions/iIcons";
import {
  callAPI,
  customValidation,
  Method,
  updateMainHeader,
  validations,
} from "../../commonFunctions/CommonFunctions";
import { breadCrumbsStore } from "../../Components/BreadCrumbs/BreadCrumbsListner";
import { useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import WSTextField, { TextType } from "../../Components/TextBox/WSTextBox";
import WSButton from "../../Components/Button/WSButton";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";

export const User: React.FC<any> = React.memo((props) => {
  const { control, register, handleSubmit, setValue } = useForm();

  const [loading, setLoading] = useState(false);
  const params = useParams();
  const id = params?.id;

  const { showMessage } = useSnackbar();
  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      const fetchData = async () => {
        try {
          const response = await callAPI(
            `Vyapar/User/${id}`,
            Method.GET
          );
          console.log('fetchData response===>', response);

          if (response && response.data) {
            const userData = response.data;
            setValue("fullName", userData.userName);
            setValue("email", userData.email);
          }
          console.log("user data is ",response.data)
        } catch (error) {
          console.error("Failed to fetch user data:", error);
        }
      };
      fetchData();
    }
  }, [id, setValue]);

  const handleData = async (data: any) => {
    try {
      setLoading(true);

      const request = {
        userName: data.fullName,
        email: data.email,
        passwordHash: data.password,
        roleId: "767E561C-0BA2-4584-BBE6-D4890363AC06",
      };

      const response = await callAPI(
        "Vyapar/User",
        Method.POST,
        request
      );

      if (response) {
        showMessage(
          response?.message,
          response.success === true ? "success" : "error"
        );

        if (response.success === true) {
          navigate("/user/list");
        }
      }
    } catch (error) {
      console.error("Failed to save user:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleCancelClick = () => {
    navigate("/user/list");
  };

  useEffect(() => {
    updateMainHeader("User");
  });

  breadCrumbsStore.updateBreadCrumbs([
    { "User List": "/user/list" },
    { [!id ? "Add User" : "Update User"]: "/add-user" },
  ]);

  const handleClose = () => {
    navigate("/user/list");
  };
  return (
    <>
      <Grid p={3}>
        <Paper
          elevation={0}
          style={{
            paddingLeft: 20,
            paddingRight: 20,
            marginTop: 0,
            paddingBottom: 25,
            borderRadius: "8px",
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12} sm={11}>
              <Typography fontWeight={"bold"}>Add User</Typography>
            </Grid>
            <Grid item xs={12} sm={1}>
              <IconButton onClick={handleClose}>
                <WSIcons.CloseIcon />
              </IconButton>
            </Grid>
            <Grid item xs={12} sm={6}>
              <WSTextField
                label={"Enter Full Name *"}
                {...register("fullName")}
                id="fullName"
                name="fullName"
                control={control}
                rules={{ required: false }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <WSTextField
                className="form-control"
                id="email"
                type={TextType.Text}
                rules={customValidation(false, validations.email)}
                {...register("email")}
                label="Email *"
                control={control}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <WSTextField
                className="form-control"
                id="password"
                type={TextType.Password}
                {...register("password")}
                label="Password *"
                control={control}
              />
            </Grid>

            {/* <Grid item xs={12} sm={6}>
              <WSSelectField
                rules={{ required: true }}
                control={control}
                id="perc"
                {...register("role")}
                name="role"
                label="Choose Your Role *"
                options={config.roleConfig.staticOptionData}
              />
            </Grid> */}
          </Grid>
        </Paper>

        <Grid container justifyContent="flex-end" spacing={2} sx={{ mt: 2 }}>
          <Grid item>
            <WSButton
              id="cancel"
              type="button"
              label="Cancel"
              size="medium"
              onClick={handleCancelClick}
              variant="outlined"
              color="primary"
            />
          </Grid>

          <Grid item>
            <WSButton
              id="submit"
              type="submit"
              label="Save"
              size="medium"
              variant="outlined"
              color="primary"
              loading={loading}
              onClick={handleSubmit(handleData)}
              sx={{
                borderRadius: 2,
                width: "6rem",
                border: "1px solid rgba(126, 176, 246, 1)",
                color: "#FFFFFF",
                backgroundColor: "rgba(126, 176, 246, 1)",
                "&:hover": {
                  backgroundColor: "rgba(126, 176, 246, 1)",
                },
              }}
            />
          </Grid>
        </Grid>
      </Grid>
    </>
  );
});
